import { IStackStyles } from "@bps/fluent-ui";

export const listWrapperStyles: IStackStyles = {
  root: {
    marginTop: 8,
    overflowY: "auto",
    height: 400
  }
};
